export default [
  {
    title: "Point Exchange",
    customIcon: "ArticleSvg",
    children: [
      {
        title: "Upload Point",
        route: "upload-point",
        path: "/point-exchange/upload-point/upload-point-list",
      },
    ],
  },
];
